import React, { useEffect, useState } from "react";
import "./ForgotPassword.css";
import { Link } from "react-router-dom";
import { Notification } from "../../../../components/ToastNotification";
import { useAddForgotPassMutation } from "../../../../Services/userApi";

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");

  // add user
  const [addForgot, { error, data, isLoading }] = useAddForgotPassMutation();
  useEffect(() => {
    if (data?.message) {
      setEmail("");
      Notification(data?.message, "success");
    } else {
      Notification(error?.data?.message, "error");
    }
  }, [error, data]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Handle the reset logic here
    if (email.trim() === "") {
      Notification("Please enter your email address", "error");
      return;
    }
    console.log("Reset link sent to:", email);
    await addForgot({ email });
  };

  return (
    <div className="fp-wrapper">
      <div className="fp-content">
        {/* Title Section */}
        <h1 className="fp-title">Forgot your Password?</h1>

        {/* Form Section */}
        <form className="fp-form" onSubmit={handleSubmit}>
          <label htmlFor="email" className="fp-label">
            Email address
          </label>

          <input
            type="email"
            id="email"
            className="fp-input"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <div className="fp-actions">
            <button type="submit" className="fp-btn" disabled={isLoading}>
              {isLoading ? "Sending..." : "Reset Password"}
            </button>

            <Link to="/login" className="fp-link">
              Back to login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
